
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 12a2 2 0 012-2h1a1 1 0 011 1v9a1 1 0 01-1 1H4a2 2 0 01-2-2v-7zM22.311 12.525A2 2 0 0020.383 10l-5.243-.002a.5.5 0 01-.485-.621l.716-2.862c.367-1.471-.336-3-1.692-3.678a1.294 1.294 0 00-1.866 1.029l-.218 2.177a3 3 0 01-.726 1.676l-2.375 2.717A2 2 0 008 11.75V19a2 2 0 002 2h7.709a3 3 0 002.894-2.21l1.708-6.265z"}})])
          )
        }
      }
    